
import { mapState, mapGetters, mapMutations } from "vuex";
import AddonsList from "./addons-list.vue";
import menuGroupBy from "./menu-group-by.vue";
import MenuNormalList from "./menu-normal-list.vue";
import MenuSoldOutList from "./menu-sold-out-list.vue";
import MenuComboList from "./menu-combo-list.vue";
import MenuItemToggleRequest from "./menu-item-toggle-request.vue";
import MenuItemModificationRequest from "./menu-item-modification-request.vue";

export default {
  components: {
    menuGroupBy,
    MenuNormalList,
    MenuSoldOutList,
    AddonsList,
    MenuComboList,
    MenuItemToggleRequest,
    MenuItemModificationRequest,
    MenuHeaderSearchField: () =>
      import("@/components/menu/menu-header-search-field.vue")
  },
  props: {
    getGroupedItemsSearchResult: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // selectedGroupBy: "",
      // selectedGroupByItem: "",
      // selectedGroupBySubItem: ""
    };
  },
  beforeMount() {},
  computed: {
    ...mapGetters("menu", ["getGroupedMenu", "getSoldOutList"]),
    ...mapState("menu", [
      "groupedMenuItems",
      "searchBy",
      "selectedGroupBy",
      "selectedGroupByItem",
      "selectedGroupBySubItem"
    ]),
    filteredItemList() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return this.getGroupedItemsSearchResult;
      }
      if (this.type === "recommended") {
        return this.getGroupedItemsSearchResult.filter(
          (item) => item.id === "recommended-items"
        );
      } else {
        return this.getGroupedItemsSearchResult.filter(
          (item) => item.id !== "recommended-items"
        );
      }
    }
    // getGroupedItems() {
    //   return this.getGroupedMenu(this.selectedGroupBy);
    // },
  },
  methods: {
    ...mapMutations("menu", [
      "SET_SELECTED_GROUP_BY_MENU",
      "SET_SELECTED_GROUP_BY_ITEM",
      "SET_SELECTED_GROUP_BY_SUB_ITEM"
    ]),
    selectedgroupByChange(val) {
      // this.selectedGroupBy = val;
      if (this.selectedGroupBy != val) {
        this.SET_SELECTED_GROUP_BY_MENU(val);
        this.selectedgroupByItemChange(null);
        this.selectedgroupBySubItemChange(null);
      }
    },
    selectedgroupByItemChange(val) {
      if (this.selectedGroupByItem !== val) {
        this.SET_SELECTED_GROUP_BY_ITEM(val);
        this.SET_SELECTED_GROUP_BY_SUB_ITEM(null);
      }
    },
    selectedgroupBySubItemChange(val) {
      this.SET_SELECTED_GROUP_BY_SUB_ITEM(val);
    }
  }
};
